import React, { useEffect, useState, Suspense, lazy } from 'react';
import img from '../../assets/banner-right.svg';
import img2 from '../../../src/assets/banner.gif'
// import video from '../../../src/assets/video-banner.mp4'
// import animationData from '../../assets/transparent lottie.json';
// const LazyLottie = lazy(() => import("lottie-react"));


const Banner = () => {
    return (
        <>
            <div className="header-section">
                <div className="container container-header">
                    <div className="row">
                        <div className="col-12">
                            <h4 className="header-span">Test. Treat. Swim.</h4>
                            <h1 className="banner-head">Crystal-Clear Pools – Free 10-Day Trial!</h1>
                            <div>
                                <ul className="banner-ul d-flex justify-content-center p-0 flex-wrap">
                                    <li>
                                        <div><img src={img} alt="Instant Safe to Swim Alerts" /></div>
                                        Instant “Safe to Swim” Alerts
                                    </li>
                                    <li>
                                        <div><img src={img} alt="Exact Dosages" /></div>
                                        Exact Dosages
                                    </li>
                                    <li>
                                        <div> <img src={img} alt="24/7 HelpBot" /></div>
                                        24/7 HelpBot
                                    </li>
                                </ul>
                            </div>
                            <div className="text-center">
                                <button className="btn btn-start landing-slider-button">Start Free Trial</button>
                            </div>
                        </div>
                    </div>
                </div>
                <br /><br />
                {/* {animationData && (
                    <Lottie animationData={animationData} loop={true} className="lottie-banner" />
                )} */}
                {/* <Suspense>
                    <LazyLottie animationData={animationData} loop={true} className="lottie-banner" />
                </Suspense> */}
               <div className='lottie-banner text-center'>
                <img src={img2} alt="" className='img-fluid'/>
               </div>

            </div>
        </>
    );
};

export default Banner;